import React, {useState} from 'react';
import {classes, style} from './doppe-action-type-widget-inner-description.st.css';
import {ClampedText, RichTextContent, richTextContentIsNullableOrWhiteSpace} from '@wix/devzai-utils-react';
import {DoppeHideableValue, doppeHideableValueIsHidden} from '../../client-server-common/types/doppe-hideable-value';
import {
    DoppeActionContentTipTapExtensions,
    DoppeRichTextContentType
} from '../../client-server-common/doppe-tiptap-extensions/doppe-tiptap-extensions';
import {WidgetRenderingContextType} from '../../client-server-common/doppe-action-types/doppe-action-type';
import {
    DoppeViewerRichTextView,
    DoppeViewerRichTextViewHtmlRenderingMode
} from '../doppe-viewer-rich-text-view/doppe-viewer-rich-text-view';
import {
    useAssertWidgetRenderingContextType
} from '../doppe-viewer-widget-rendering-context/doppe-viewer-widget-rendering-context';
import {
    DoppeActionTypeWidgetShowMoreButton
} from '../doppe-action-type-widget-show-more-button/doppe-action-type-widget-show-more-button';

export const DoppeActionTypeWidgetInnerDescription = React.memo(function DoppeActionTypeWidgetInnerDescription(props: DoppeActionTypeWidgetInnerDescription.Props) {
    const {
        children,
        maxLines = 4,
        forceMaxLines = false,
        className,
        showSeeMoreButton = true,
        ignoreRenderingContextType = false,

        ...htmlAttributes
    } = props;

    const [shouldClamp, setShouldClamp] = useState(true);
    const [isClamped, setIsClamped] = useState(false);
    const widgetRenderingContextType = useAssertWidgetRenderingContextType();

    const calculatedMaxLines = (widgetRenderingContextType === WidgetRenderingContextType.Modal && !ignoreRenderingContextType ? Infinity : maxLines);

    if (doppeHideableValueIsHidden(children) || richTextContentIsNullableOrWhiteSpace(children, DoppeActionContentTipTapExtensions)) {
        return null;
    }

    return (
        <div
            {...htmlAttributes}
            className={style(classes.root, className)}
        >
            <ClampedText
                className={style(classes.content, {})}
                maxLines={forceMaxLines ? maxLines : calculatedMaxLines}
                onIsClampedChanged={setIsClamped}
                clampText={shouldClamp}
            >
                {typeof children === 'string' ? children : (
                    <DoppeViewerRichTextView
                        richText={children}
                        richTextContentType={DoppeRichTextContentType.DoppeActionContent}
                        htmlRenderingMode={DoppeViewerRichTextViewHtmlRenderingMode.FullRichText}
                    />
                )}
            </ClampedText>
            {isClamped && showSeeMoreButton ? (
                <DoppeActionTypeWidgetShowMoreButton
                    isOpen={!shouldClamp}
                    onClick={() => {
                        setShouldClamp(shouldClamp => !shouldClamp);
                    }}
                />
            ) : null}
        </div>
    );
});

export namespace DoppeActionTypeWidgetInnerDescription {

    export interface Props extends React.HTMLAttributes<any> {
        children: DoppeHideableValue<RichTextContent>;
        maxLines?: number;
        forceMaxLines?: boolean;
        showSeeMoreButton?: boolean;
        ignoreRenderingContextType?: boolean;
    }
}

